
import { fetchConToken } from "../../../helpers/fetch";
import { AppDispatch } from "../../store";
import { SeccionState, setSeccion, setSecciones } from "../seccion/seccionSlice";

import { setSeccionDiapositivas, startLoadingSeccionDiapositiva, endLoadingSeccionDiapositiva, SeccionDiapositivaState, DiapositivaState } from './seccionDiapositivaSlice';

export const obtenerSeccionDiapositivaBloque = (bid: string) => {

    return async (dispatch: AppDispatch) => {

        try {
            const resp = await fetchConToken(`seccion-diapositiva/obtener/${bid}`);
            const body = await resp.json();

            if (body.ok) {
                const { diapositivas } = body;

                const diapositivasBloque = diapositivas.map((item: any) => item.diapositivas).flat(1);

                dispatch(setSeccionDiapositivas(diapositivasBloque));
                dispatch(endLoadingSeccionDiapositiva())
                return 
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export const obtenerSeccionDiapositivaSeccion = (sid: string) => {

    return async (dispatch: AppDispatch) => {

        try {
            const resp = await fetchConToken(`seccion-diapositiva/obtener/${sid}`);
            const body = await resp.json();

            console.log(body)

            if (body.ok) {
                const { secciones } = body;

                // dispatch(setSecciones(secciones));
                // dispatch(endLoadingSeccion())
                return 
            }
        } catch (error) {
            console.log(error)
        }
    }
}





// ADMINISTRADOR
export const crearSeccionDiapositiva = (diapositiva: SeccionDiapositivaState) => {

    return async (dispatch: AppDispatch, getState: any) => {

        const { secciones } = getState().seccion;

        try {
            const resp = await fetchConToken(`seccion-diapositiva/crear`, diapositiva, 'POST');
            const body = await resp.json();

            if (body.ok) {
                const { seccionDiapositivaCreada } = body;
                const { sid, diapositivas } = seccionDiapositivaCreada;

                const seccionesActualizada = secciones.map((item: SeccionState) => 
                    item.sid === sid ? {...item, diapositivas} : item
                );

                dispatch(setSecciones(seccionesActualizada))
                return seccionesActualizada.find((item: SeccionState) => item.sid === sid )
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export const eliminarSeccionDiapositiva = (sid: string) => {

    return async (dispatch: AppDispatch, getState: any) => {

        const { secciones } = getState().seccion;

        try {
            const resp = await fetchConToken(`seccion-diapositiva/eliminar/${sid}`, { sid: sid }, 'DELETE');
            const body = await resp.json();

            if (body.ok) {
                const seccionesActualizada = secciones.map((item: SeccionState) => 
                    item.sid === sid ? {
                        cid: item.cid,
                        mid: item.mid,
                        bid: item.bid,
                        sid: item.sid,
                        seccion: item.seccion,
                        nombre: item.nombre,
                        diapositivas: [],
                        ejercicios: item.ejercicios
                    } : item
                );
                dispatch(setSecciones(seccionesActualizada))
                return 
            }
        } catch (error) {
            console.log(error)
        }
    }
}

export const actualizarSeccionDiapositiva = (diapositiva: SeccionDiapositivaState) => {

    return async (dispatch: AppDispatch, getState: any) => {

        const { sid } = diapositiva;

        const { secciones } = getState().seccion;

        try {
            const resp = await fetchConToken(`seccion-diapositiva/actualizar/${sid}`, diapositiva, 'PUT');
            const body = await resp.json();

            if (body.ok) {
                const seccionesActualizada = secciones.map((item: SeccionState) => 
                    item.sid === sid ? {
                        cid: item.cid,
                        mid: item.mid,
                        bid: item.bid,
                        sid: item.sid,
                        seccion: item.seccion,
                        nombre: item.nombre,
                        autor: diapositiva.autor, 
                        diapositivas: diapositiva.diapositivas,
                        ejercicios: item.ejercicios
                    } : item
                );

                const seccion = secciones.find((item: SeccionState) => item.sid === sid);

                dispatch(setSeccion({...seccion, diapositivas: diapositiva.diapositivas}));
                dispatch(setSecciones(seccionesActualizada));
                return 
            }
        } catch (error) {
            console.log(error)
        }
    }
}
